import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromMessages from '../fromMessages.barrel';

const selectState = createFeatureSelector<fromMessages.State>(fromMessages.messageFeatureKey);

export const selectToasts = createSelector(selectState, state => state.toasts);
export const selectLog = createSelector(selectState, state => state.log);
